import React from 'react';
import PropTypes from 'prop-types';

import {classNames} from '~/src/utilities/helpers/css';
import {ButtonFormat, ColorScheme} from '~/src/utilities/constants/formats';
import {withTypeContext} from '~/src/components/context/TypeContext';
import {withSettingsContext} from '~/src/components/context/SettingsContext';

import css from './ActivityButton.module.scss';

const ActivityButton = ({children, activityCount, highlighted: isHighlighted, format, colorScheme, action, context, isDisabled, ...props}) => {
    const classes = classNames(css, 'activityButton', format, colorScheme, action, context.type, context.settings.siteArea, {isHighlighted, isDisabled});

    const showCounter = format !== ButtonFormat.BUTTON_ACTION_BUBBLE;

    return (
        <button {...props} className={classes}>
            <span className={css.activityIcon}>{children}</span>
            {showCounter && <span className={css.activityCounter}>{activityCount}</span>}
        </button>
    );
};

if (process.env.NODE_ENV === 'development') {
    ActivityButton.propTypes = {
        activityCount: PropTypes.number,
        isDisabled: PropTypes.bool,
        isHighlighted: PropTypes.bool,
        format: PropTypes.oneOf(Object.values(ButtonFormat)).isRequired,
        colorScheme: PropTypes.oneOf(Object.values(ColorScheme)),
        action: PropTypes.string,
        context: PropTypes.shape({
            type: PropTypes.string
        })
    };
}

export default withSettingsContext(withTypeContext(ActivityButton));
